import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";

import { Header, Loading } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import constansts from "../../constants";

export const ReportCoupon = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs, profileState } = Context();
  const [coupons, setCoupons] = useState(false);
  const [bundleOrders, setBundleOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("all");
  const [dashboard, setDashboard] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);
    const queries = [["status", "==", statuses.APPROVE]];

    if (type !== "all") {
      queries.push(["coupon.type", "==", type]);
    }

    const [data, bundleData] = await Promise.all([
      callApi(
        "coupons-getAllCouponOrders",
        {
          queries,
          limit: 50000,
          roundDate: selectedRoundDate,
          orderBy: ["createdAt", "desc"],
        },
        { notShowLoading: true },
      ),
      callApi(
        "coupons-getAllBundleOrders",
        {
          queries: [["status", "==", statuses.APPROVE]],
          roundDate: selectedRoundDate,
          limit: 5000,
          orderBy: ["createdAt", "desc"],
        },
        { notShowLoading: true },
      ),
    ]);

    const normalizedBundles = Array.isArray(bundleData) ? bundleData : [];
    setCoupons(data);
    setBundleOrders(normalizedBundles);
    setLoading(false);
    const getDash = data.reduce(
      (acc, couponOrder) => {
        if (couponOrder.coupon.type === "reserve") {
          acc.total += couponOrder.coupon.quantity;
          acc.used += couponOrder.coupon.reserveOrder.filter(
            (x) => x.status === "used",
          ).length;
          acc.pending += couponOrder.coupon.reserveOrder.filter(
            (x) => x.status === "pending",
          ).length;
          acc.unused +=
            couponOrder.coupon.quantity -
            couponOrder.coupon.reserveOrder.length;
        }
        acc[`${couponOrder.coupon.type}`] += 1;
        acc.income += Number(couponOrder.price);

        return acc;
      },
      {
        total: 0,
        used: 0,
        pending: 0,
        unused: 0,
        income: 0,
        reserve: 0,
        discount: 0,
        voucher: 0,
      },
    );

    const bundleIncome = normalizedBundles.reduce(
      (acc, order) => acc + Number(order.price || 0),
      0,
    );

    setDashboard({
      ...getDash,
      bundleCount: normalizedBundles.length,
      bundleIncome,
    });
  };

  const handleDownload = async () => {
    const bundleShortIdMap = (
      Array.isArray(bundleOrders) ? bundleOrders : []
    ).reduce((map, b) => {
      map[b.id] = b.shortId;
      return map;
    }, {});

    const arr = [
      [`รายงานคูปอง_${thaiDate()}`],
      [
        `คำสั่งซื้อทั้งหมด ${coupons.length}`,
        `รายได้ทั้งหมด ${(dashboard?.income || 0)?.toLocaleString()} บาท`,
      ],
      [
        `คูปองจองสิทธิ์ ${(
          dashboard?.reserve || 0
        )?.toLocaleString()} คำสั่งซื้อ`,
        `คูปองสลาก ${(dashboard?.voucher || 0)?.toLocaleString()} คำสั่งซื้อ`,
        `คูปองส่วนลด ${(
          dashboard?.discount || 0
        )?.toLocaleString()} คำสั่งซื้อ`,
      ],
      [
        `จำนวนสิทธิ์ทั้งหมด ${(
          dashboard?.total || 0
        )?.toLocaleString()} สิทธิ์`,
        `สิทธิ์ใช้แล้ว ${(dashboard?.used || 0)?.toLocaleString()} สิทธิ์`,
        `สิทธิ์รอดำเนินการ ${(
          dashboard?.pending || 0
        )?.toLocaleString()} สิทธิ์`,
        `สิทธิ์ที่ไม่ได้ใช้ ${(
          dashboard?.unused || 0
        )?.toLocaleString()} สิทธิ์`,
      ],
      [""],
      [""],
      [
        "ลำดับ",
        "วัน-เวลา",
        "รหัสคำสั่งซื้อ",
        "รหัสสมาชิก",
        "ชื่อ-นามสกุล",
        "ราคา",
        "ชื่อคูปอง",
        "จำนวนสิทธ์",
        "สถานะ",
      ],
    ];

    const combinedForCsv = [
      ...coupons.map((o) => ({ ...o, _type: "coupon" })),
      ...(Array.isArray(bundleOrders) ? bundleOrders : []).map((o) => ({
        ...o,
        _type: "bundle",
      })),
    ].sort((a, b) => b.createdAt - a.createdAt);

    combinedForCsv.forEach((order, index) => {
      if (order._type === "bundle") {
        const totalQty = (order.bundle?.items || []).reduce(
          (acc, item) => acc + (item.quantity || 0),
          0,
        );
        arr.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          order.shortId,
          order.userData?.userId,
          order.userData?.name,
          Number(order.price || 0).toLocaleString(),
          `[แพ็กเกจ] ${order.bundle?.name || ""}`,
          totalQty || "",
          constansts.statusesTranslate[order.status] || order.status,
        ]);
      } else {
        arr.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
          order.shortId,
          order.userData.userId,
          order.userData.name,
          order.price.toLocaleString(),
          bundleShortIdMap[order.bundleOrderId]
            ? `[#${bundleShortIdMap[order.bundleOrderId]}] ${order.coupon?.name || ""}`
            : order.coupon?.name || "",
          order.coupon.type === "reserve"
            ? order.coupon.reserveOrder.length + "/" + order.coupon.quantity
            : "",
          order.coupon?.status === "pending"
            ? "รอดำเนินการ"
            : constansts.statusesTranslate[order.coupon?.status],
        ]);

        if (
          order.coupon.type === "reserve" &&
          order.coupon.reserveOrder.length > 0
        ) {
          order.coupon?.reserveOrder.map((resOrder) =>
            arr.push([
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              `${
                resOrder?.status === "used"
                  ? resOrder.shortId || resOrder.orderId
                  : constansts.statusesTranslate[resOrder?.status]
              } | เลขท้าย ${resOrder.number} จำนวน ${resOrder.quantity} ใบ`,
            ]),
          );
        }
      }
    });

    setCsvData(arr);
    setCsvFileName(`รายงานคูปองงวด_${selectedRoundDate}.csv`);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานคูปอง"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold ">รายงานคูปอง</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full border-[#E5E7E9] rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="">
            <p className="font-medium text-xs">ประเภท</p>
            <div>
              <select
                className="border-2 w-full border-[#E5E7E9] rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="all">ทั้งหมด</option>
                <option value="discount">คูปองส่วนลด</option>
                <option value="reserve">คูปองจองสิทธิ์</option>
                <option value="voucher">คูปองสลาก</option>
              </select>
            </div>
          </div>
          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!coupons.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {/* admins */}
      {coupons && (
        <div className="grid grid-cols-5 gap-2 my-3">
          <div className="flex flex-col h-fit py-1 px-3 bg-[#52B788] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              คำสั่งซื้อสำเร็จ
            </p>
            <div className="text-xl font-bold text-right">
              {!coupons.length ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (coupons.length || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                คำสั่งซื้อ
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3  bg-teal-500 text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              รายได้ทั้งหมด
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.income || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                บาท
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#2E5077] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              คูปองจองสิทธิ์
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.reserve || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                คำสั่งซื้อ
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#FA812F] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">คูปองสลาก</p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.voucher || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                คำสั่งซื้อ
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#9F5255] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">คูปองส่วนลด</p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.discount || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                คำสั่งซื้อ
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#FAB12F] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              จำนวนสิทธิ์ทั้งหมด
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.total || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                สิทธิ์
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#52B788] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              สิทธิ์ใช้แล้ว
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.used || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                สิทธิ์
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#592941] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              สิทธิ์รอดำเนินการ
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.pending || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                สิทธิ์
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#525458] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              สิทธิ์ที่ไม่ได้ใช้
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.unused || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                สิทธิ์
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#6366f1] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              คำสั่งซื้อแพ็กเกจ
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.bundleCount || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                คำสั่งซื้อ
              </p>
            </div>
          </div>
          <div className="flex flex-col h-fit py-1 px-3 bg-[#0891b2] text-white rounded-lg duration-300 shadow-md hover:shadow-xl">
            <p className="text-sm font-semibold opacity-80 py-1">
              รายได้แพ็กเกจ
            </p>
            <div className="text-xl font-bold text-right">
              {!dashboard ? (
                <Loading className="w-4 h-4 text-bold" />
              ) : (
                (dashboard?.bundleIncome || 0)?.toLocaleString()
              )}
              <p className="text-sm text-right font-semibold opacity-80 py-1">
                บาท
              </p>
            </div>
          </div>
        </div>
      )}
      {coupons !== false &&
        (() => {
          const bundleShortIdMap = (
            Array.isArray(bundleOrders) ? bundleOrders : []
          ).reduce((map, b) => {
            map[b.id] = b.shortId;
            return map;
          }, {});
          const combinedOrders = [
            ...coupons.map((o) => ({ ...o, _type: "coupon" })),
            ...(Array.isArray(bundleOrders) ? bundleOrders : []).map((o) => ({
              ...o,
              _type: "bundle",
            })),
          ].sort((a, b) => b.createdAt - a.createdAt);
          return (
            <div className="relative bg-white w-full rounded-lg shadow-md border border-[#E5E7E9] overflow-hidden">
              <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
                <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
                <p className="text-xs font-semibold text-[#969797]">
                  {combinedOrders.length} คำสั่งซื้อ
                </p>
              </div>
              <Table>
                <TableHeader className={`bg-[#f2f3f5]`}>
                  <TableRow>
                    <TableHead className="text-center">ลำดับ</TableHead>
                    <TableHead className="">วันที่-เวลา</TableHead>
                    <TableHead className="">รหัสคำสั่งซื้อ</TableHead>
                    <TableHead className="">รหัสสมาชิก</TableHead>
                    <TableHead className="">ชื่อ-นามสกุล</TableHead>
                    <TableHead className="text-center">ราคา</TableHead>
                    <TableHead>ชื่อคูปอง</TableHead>
                    <TableHead>จำนวนสิทธ์</TableHead>
                    <TableHead className="text-center">สถานะ</TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody className={``}>
                  {combinedOrders.length > 0 ? (
                    combinedOrders.map((order, index) => {
                      if (order._type === "bundle") {
                        const totalQty = (order.bundle?.items || []).reduce(
                          (acc, item) => acc + (item.quantity || 0),
                          0,
                        );
                        return (
                          <TableRow key={order.id}>
                            <TableCell className="font-semibold text-center align-baseline ">
                              {index + 1}
                            </TableCell>
                            <TableCell
                              className={`font-semibold align-baseline `}
                            >
                              {new Date(order.createdAt).toLocaleDateString(
                                "th-TH",
                                {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                  hour: "numeric",
                                  minute: "numeric",
                                },
                              )}{" "}
                              น.
                            </TableCell>
                            <TableCell className="font-semibold align-baseline ">
                              {order.shortId}
                            </TableCell>
                            <TableCell className="font-semibold align-baseline ">
                              {order.userData?.userId}
                            </TableCell>
                            <TableCell className="font-semibold align-baseline">
                              {order.userData?.name}
                            </TableCell>
                            <TableCell className="font-semibold align-baseline text-center">
                              {Number(order.price || 0).toLocaleString()}
                            </TableCell>
                            <TableCell className="font-semibold align-baseline">
                              <span className="mr-1 rounded bg-indigo-100 px-1.5 py-0.5 text-xs text-indigo-600">
                                แพ็กเกจ
                              </span>
                              {order.bundle?.name || ""}
                            </TableCell>
                            <TableCell className={`font-semibold `}>
                              {totalQty > 0 ? totalQty : ""}
                            </TableCell>
                            <TableCell className="font-semibold text-center align-baseline">
                              (
                              {constansts.statusesTranslate[order.status] ||
                                order.status}
                              )
                            </TableCell>
                          </TableRow>
                        );
                      }
                      return (
                        <TableRow key={order.id}>
                          <TableCell className="font-semibold text-center align-baseline ">
                            {index + 1}
                          </TableCell>
                          <TableCell
                            className={`font-semibold align-baseline `}
                          >
                            {new Date(order.createdAt).toLocaleDateString(
                              "th-TH",
                              {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                              },
                            )}{" "}
                            น.
                          </TableCell>
                          <TableCell className="font-semibold align-baseline ">
                            {order.shortId}
                          </TableCell>
                          <TableCell className="font-semibold align-baseline ">
                            {order.userData.userId}
                          </TableCell>
                          <TableCell className="font-semibold align-baseline">
                            {order.userData.name}
                          </TableCell>
                          <TableCell className="font-semibold align-baseline text-center">
                            {order.price.toLocaleString()}
                          </TableCell>
                          <TableCell className="font-semibold align-baseline">
                            {bundleShortIdMap[order.bundleOrderId] && (
                              <span className="mr-1 rounded bg-indigo-100 px-1.5 py-0.5 text-xs text-indigo-600">
                                #{bundleShortIdMap[order.bundleOrderId]}
                              </span>
                            )}
                            {order.coupon?.name || ""}
                          </TableCell>
                          <TableCell className={`font-semibold `}>
                            {order.coupon.type === "reserve" &&
                              order.coupon.reserveOrder.length +
                                "/" +
                                order.coupon.quantity}
                            {order.coupon.type === "reserve"
                              ? order.coupon?.reserveOrder.map((resOrder) => (
                                  <p
                                    className={`${
                                      resOrder?.status === "used"
                                        ? "text-green"
                                        : "text-yellow-600"
                                    } `}
                                  >
                                    {resOrder?.status === "used"
                                      ? resOrder.shortId || resOrder.orderId
                                      : constansts.statusesTranslate[
                                          resOrder?.status
                                        ]}{" "}
                                    | เลขท้าย {resOrder.number} จำนวน{" "}
                                    {resOrder.quantity} ใบ
                                  </p>
                                ))
                              : order.coupon?.usedBy || ""}
                          </TableCell>
                          <TableCell className="font-semibold text-center align-baseline">
                            (
                            {constansts.statusesTranslate[order.coupon?.status]}
                            )
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableCell className="" colSpan="9">
                      <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                        <div>
                          <MdPersonSearch className="text-white" />
                          ไม่พบคำสั่งซื้อ
                        </div>
                      </div>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
          );
        })()}
    </div>
  );
};
